export const SET_PRODUTOS = (state, payload) => {
  state.produtos = payload;
};